import type {
  DeliveryNoteDetailDto,
  DeliveryNoteItemDto,
} from "@hisense/shared";
import { exportCsv, fileStamp } from "./exportCsv";
export function exportDeliveryCsv(
  dn: DeliveryNoteDetailDto,
  t: (key: string) => string,
) {
  type Row = Partial<DeliveryNoteItemDto> & { label?: string };
  const rows: Row[] = [
    ...dn.items,
    { label: "" },
    ...(dn.quantities ?? []).map((q) => ({
      label: t("print.total"),
      unit: q.unit,
      orderedQty: q.planned,
      deliveredQty: q.received,
    })),
  ];
  exportCsv(
    `delivery-note-${dn.dnNo}-${fileStamp()}`,
    [
      {
        header: t("deliveryNotes.itemNo"),
        value: (r: Row) => r.label ?? r.itemNo,
      },
      { header: t("common.subRef"), value: (r: Row) => r.subRef },
      { header: t("deliveryNotes.ctnNo"), value: (r: Row) => r.ctnNo },
      { header: t("common.description"), value: (r: Row) => r.description },
      { header: t("lot.number"), value: (r: Row) => r.lotNumber },
      {
        header: t("deliveryWorkspace.planned"),
        value: (r: Row) => r.orderedQty,
      },
      {
        header: t("deliveryWorkspace.received"),
        value: (r: Row) => r.deliveredQty,
      },
      { header: t("common.unit"), value: (r: Row) => r.unit },
      { header: t("common.lineRemark"), value: (r: Row) => r.remarks },
    ],
    rows,
  );
}
